import React, { useState, useEffect, useRef } from 'react';

const MAPBOX_TOKEN = window.REACT_APP_MAPBOX_TOKEN;

const MiniMap = ({ latitude, longitude, title }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    if (!MAPBOX_TOKEN || !mapContainer.current || map.current) return;
    if (typeof window.mapboxgl === 'undefined') return;

    window.mapboxgl.accessToken = MAPBOX_TOKEN;

    map.current = new window.mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [parseFloat(longitude) || 78.4867, parseFloat(latitude) || 10.7905],
      zoom: 14,
    });

    // Add marker
    new window.mapboxgl.Marker()
      .setLngLat([parseFloat(longitude), parseFloat(latitude)])
      .addTo(map.current);

    map.current.addControl(new window.mapboxgl.NavigationControl(), 'top-left');

    return () => {
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, [latitude, longitude]);

  if (!MAPBOX_TOKEN || !latitude || !longitude) {
    return (
      <div className="h-64 bg-neutral-100 rounded-xl flex items-center justify-center">
        <p className="text-neutral-500 text-sm">Location not available</p>
      </div>
    );
  }

  return (
    <div className="h-64 rounded-xl overflow-hidden border border-neutral-200">
      <div ref={mapContainer} className="w-full h-full" />
    </div>
  );
};

export default MiniMap;